(function () {
    'use strict';

    if (window.rdHeaderLayout) {
        window.rdHeaderLayout.refresh();
        return;
    }

    var dispose = function () {};

    function refresh() {
        dispose();
        var header = document.getElementById('velaHeader');
        if (!header) return;
        var section = header.closest('.shopify-section');
        var row = header.querySelector('.headerContent');
        var left = header.querySelector('.velaHeaderLeft');
        var right = header.querySelector('.velaHeaderRight');
        var center = header.querySelector('.velaHeaderCenter');
        var nav = header.querySelector('.menuContainer > .nav');
        var button = header.querySelector('#btnMenuMobile');
        var drawer = section && section.querySelector('#velaMenuMobile');
        if (!section || !row || !left || !right || !center || !nav || !button || !drawer) return;

        var frame = 0;
        var active = true;
        var desktop = window.matchMedia('(min-width: 992px)');

        function measure() {
            frame = 0;
            if (!active || !header.isConnected) return;
            var compact = false;
            if (desktop.matches) {
                var gap = parseFloat(window.getComputedStyle(row).columnGap) || 0;
                var available = row.clientWidth - left.getBoundingClientRect().width
                    - right.getBoundingClientRect().width - gap * 2;
                compact = Math.ceil(nav.getBoundingClientRect().width) > Math.floor(available);
            }
            section.toggleAttribute('data-rd-header-compact', compact);
            var hideDesktopNav = !desktop.matches || compact;
            center.inert = hideDesktopNav;
            center.setAttribute('aria-hidden', String(hideDesktopNav));
            if (desktop.matches && !compact) document.body.classList.remove('menuMobileActive');
            button.setAttribute('aria-expanded', String(document.body.classList.contains('menuMobileActive')));
        }

        function schedule() {
            if (!frame && active) frame = window.requestAnimationFrame(measure);
        }

        var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
        if (resize) [row, left, right, nav].forEach(function (element) { resize.observe(element); });
        var labels = new MutationObserver(schedule);
        labels.observe(nav, { childList: true, characterData: true, subtree: true });
        var state = new MutationObserver(function () {
            button.setAttribute('aria-expanded', String(document.body.classList.contains('menuMobileActive')));
        });
        state.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('resize', schedule);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
        measure();

        dispose = function () {
            active = false;
            if (frame) window.cancelAnimationFrame(frame);
            if (resize) resize.disconnect();
            labels.disconnect();
            state.disconnect();
            window.removeEventListener('resize', schedule);
        };
    }

    window.rdHeaderLayout = { refresh: refresh };
    refresh();
    document.addEventListener('shopify:section:load', refresh);
})();
